<template>
    <div class="editable-update">
        <div>
            <b-row>
                <b-col xs="12" md="8">
                    <div v-if="!is_editing">
                        <update :update="update"></update>
                    </div>

                    <div class="edit-update__form-wrapper" v-else>
                        <b-form @submit.prevent="onSubmit()">
                            <b-form-group>
                                <label>
                                    Title
                                </label>

                                <b-form-input
                                    class="tb-form-field"
                                    type="text"
                                    v-model="form.title"
                                    required>
                                </b-form-input>

                                <label>
                                    Body
                                </label>

                                <div class="wysiwyg-boxed">
                                    <vue-editor
                                        v-model="form.body"
                                        :editorToolbar="
                                    [
                                        ['bold', 'italic', 'underline'],
                                        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                                        ['code-block'],
                                        [{align: ''}, {align: 'center'}, {align: 'right'}]
                                    ]"></vue-editor>
                                </div>
                            </b-form-group>

                            <b-button type="submit" variant="primary" class="tb-button tb-button--small tb-button--blue">
                                Submit
                            </b-button>
                        </b-form>
                    </div>
                </b-col>

                <b-col xs="12" md="4">
                    <div class="text-right itinerary-edit">
                        <a href="#" class="mr-2 tb-table__button tb-table__button--gold" @click.prevent="toggleEdit">
                            {{ !is_editing ? "Edit" : "Cancel editing" }}
                        </a>

                        <a href="#" class="tb-table__button tb-table__button--blue" @click.prevent="askDeleteItem">
                            Delete
                        </a>
                    </div>
                </b-col>
            </b-row>

<!--            <div v-if="!is_editing">-->
<!--                <update :update="update"></update>-->
<!--            </div>-->

<!--            <div v-else>-->
<!--                <b-form @submit.prevent="onSubmit()">-->
<!--                    <b-form-group>-->
<!--                        -->
<!--                        <label>-->
<!--                            Title-->
<!--                        </label>-->

<!--                        <b-form-input-->
<!--                            type="text"-->
<!--                            v-model="form.title"-->
<!--                            required>    -->
<!--                        </b-form-input>-->
<!--                        -->
<!--                        <label>-->
<!--                            Body-->
<!--                        </label>-->

<!--                        <vue-editor-->
<!--                            v-model="form.body"-->
<!--                            :editorToolbar="-->
<!--                            [-->
<!--                                ['bold', 'italic', 'underline'],-->
<!--                                [{ 'list': 'ordered'}, { 'list': 'bullet' }],-->
<!--                                ['code-block']-->
<!--                            ]"></vue-editor>-->

<!--                        &lt;!&ndash; <b-form-textarea-->
<!--                            v-model="form.body"-->
<!--                            required>    -->
<!--                        </b-form-textarea> &ndash;&gt;-->
<!--                    </b-form-group>-->

<!--                    <b-button type="submit" variant="primary">-->
<!--                        Submit-->
<!--                    </b-button>-->
<!--                </b-form>-->
<!--            </div>-->

<!--            <div class="text-right">-->
<!--                <a href="#" class="text-primary font-weight-bold mr-2" @click.prevent="toggleEdit">-->
<!--                    {{ !is_editing ? "Edit" : "Cancel editing" }}-->
<!--                </a>-->

<!--                <a href="#" class="text-danger font-weight-bold" @click.prevent="askDeleteItem">-->
<!--                    Delete-->
<!--                </a>-->
<!--            </div>-->
        </div>

        <b-modal
            v-model="show_delete_modal"
            id="delete-modal"
            title="Warning"
            @ok="deleteItem()"
            header-bg-variant="danger"
            header-text-variant="light"
            ok-title="Delete"
            ok-variant="danger">
            Are you sure you want to permanently delete this update?
        </b-modal>
    </div>
</template>

<script>
    import Update from '@/components/Update.vue';
    import { VueEditor } from "vue2-editor";

    export default {
        props: ['update'],

        components: {
            Update, 
            VueEditor
        },

        data() {
            return {
                is_editing: false,
                show_delete_modal: false
            }
        },

        computed: {
            form() {
                return {
                    ...this.update
                }
            }
        },

        methods: {
            onSubmit() {
                this.$emit('changed', { ...this.form });
                this.is_editing = false;
            },

            toggleEdit() {
                this.is_editing = !this.is_editing;
            },

            askDeleteItem() {
                this.show_delete_modal = true;
            },
            
            deleteItem() {
                this.$emit('deleted', { ...this.form });
            }
        }
    }
</script>

<style scoped lang="scss">
    form {
        margin-bottom: 10px;
    }

    .form-group {
        margin-bottom: 0;
        margin-bottom: 10px;
    }

    .alert {
        margin-top: 5px;
    }

    textarea {
        margin-bottom: 10px;
    }

    .editable-update {
        margin-top: 1rem;
        border-bottom: 1px solid $color-light-blue;
    }

    .edit-update {

        &__form-wrapper {

        }
    }
</style>